import React from 'react';
import { useTranslation } from 'react-i18next';

export default function ProfileCompletion({ percent = 0, tips = [] }) {
    const { t } = useTranslation(['marketplace', 'profile']);
    const p = Math.min(100, Math.max(0, Number(percent) || 0));

    return (
        <div className="mp-completion">
            <div className="mp-completion__header">
                <span>{t('marketplace:profileEdit.completionLabel', { percent: p })}</span>
                <strong>{p}%</strong>
            </div>
            <div className="mp-completion__bar">
                <div className="mp-completion__fill" style={{ width: `${p}%` }} />
            </div>
            <p className="mp-completion__hint">{t('marketplace:profileEdit.completionHint')}</p>
            {tips.length > 0 && (
                <ul className="mp-completion__tips">
                    {tips.map((tip) => (
                        <li key={tip}>💡 {tip}</li>
                    ))}
                </ul>
            )}
        </div>
    );
}
